exports.SimpleGlobal = require('./lib/simple-global').SimpleGlobal;



//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/ng2-simple-global/index.js
// module id = ../../../../ng2-simple-global/index.js
// module chunks = 3